export {
  default as spinner,
  type Spinner,
  type Ora as SpinnerInstance,
  type Options as SpinnerOptions,
  oraPromise as spinnerPromise,
  type PromiseOptions as SpinnerPromiseOptions,
} from 'ora'
